import { SignupComponent } from './components/signup/signup.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { UserService } from './services/user.service';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SignupSuccessComponent } from './components/signup-success/signup-success.component';
import { ProgramComponent } from './components/program/program.component';
import { ForgotPasswordComponent } from './components/login/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './components/login/change-password/change-password.component';
import { ErrorComponent } from './components/error/error.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { EnrollmentClosedComponent } from './components/enrollment-closed/enrollment-closed.component';
import { ApplicationCheckinComponent } from './components/survey/application-check-in/application-check-in.component';
import { SatisfactionSurveyComponent } from './components/survey/satisfaction-survey/satisfaction-survey.component';
import { CleanRowPhotosComponent } from './components/survey/clean-photos/clean-photos.component';
import { EndOfSeasonSurveyComponent } from './components/survey/end-of-season-survey/end-of-season-survey.component';
import { ProgramCompleteComponent } from './components/survey/program-complete/program-complete.component';
import { RedirectExternalComponent } from './components/Redirect/RedirectExternalComponent';
const routes: Routes = [
  { path: 'log-in', component: LoginComponent },
  { path: 'login/callback', component: OktaCallbackComponent, canActivate: [UserService] },
  { path: 'sign-up',redirectTo:'enrollment-close' ,pathMatch: 'full' },
 // { path: 'sign-up', component: SignupComponent },
  { path: 'sign-up/success', component: SignupSuccessComponent },
  { path: 'sign-up/welcome', component: WelcomeComponent },
  { path: 'program', component: ProgramComponent },
  { path: 'log-in/activate', component: LoginComponent },
  { path: 'log-in/forgot-password', component: ForgotPasswordComponent },
  { path: 'log-in/change-password', component: ChangePasswordComponent },
  { path: 'error', component: ErrorComponent },
  { path: '', component: HeaderComponent, outlet: 'header' },
  { path: '', component: FooterComponent, outlet: 'footer' },
  { path: '', component: RedirectExternalComponent, pathMatch: 'full' },
  // { path: '', component: ProgramComponent },
  { path: 'application-checkin', component: ApplicationCheckinComponent },
  { path: 'satisfaction-survey', component: SatisfactionSurveyComponent },
  { path: 'clean-row-photos', component: CleanRowPhotosComponent },
  { path: 'end-of-season-survey', component: EndOfSeasonSurveyComponent },
  { path: 'program-complete', component: ProgramCompleteComponent },
  { path: 'enrollment-close', component: EnrollmentClosedComponent },
  { path: '**', component: ErrorComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{onSameUrlNavigation:'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
